import UserActivityService from "@/services/UserActivityService";

const initState = {
  userId: "",
  progress: [],
  currentLesson: null,
  updateInterval: null,
  activityTimeout: null,
  studyInProgress: false,
};

class Activity {
  constructor(lessonId) {
    this.lessonId = lessonId;
    this.duration = 0;
    this.startTime = new Date().getTime();
  }

  updateDuration() {
    const delta = new Date().getTime() - this.startTime;
    this.duration += delta;
    this.setNewStartTime();
  }

  setNewStartTime() {
    this.startTime = new Date().getTime();
  }
}

const storeGetters = {
  getUser: (state) => {
    return state.user;
  },
};
const actions = {
  initStore({ commit, rootGetters }) {
    const user = rootGetters["UserStore/getUser"];
    commit("setUserData", user);
  },
  startLesson({ commit, dispatch }, payload) {
    const { lessonId } = payload;

    dispatch("startTrack", { lessonId });
  },
  startTrack({ commit, dispatch, state }, payload) {
    const { lessonId } = payload;
    commit("setLesson", lessonId);

    commit("setStudyInProgress", true);
    // const UPDATE_INTERVAL = 1000;
    // const interval = setInterval(() => {
    // if (state.studyInProgress) {
    //   commit("updateProgress", lessonId);
    // } else {
    //   dispatch("stopLesson");
    // }
    // }, UPDATE_INTERVAL);
    // dispatch("studyInProgress", { lessonId });
    // commit("setInterval", interval);
  },
  studyInProgress({ state, commit, dispatch }, payload) {
    const { lessonId } = payload;
    const NO_ACTIVITY_RANGE = 60 * 1000;
    if (state.studyInProgress) {
      // clearInterval(state.activityInterval);
      commit("setActivityTimeout", null);
      // const activityTimeout = setTimeout(() => {
      commit("setStudyInProgress", false);
      // }, NO_ACTIVITY_RANGE);
      commit("setActivityTimeout", activityTimeout);
    } else {
      dispatch("startTrack", { lessonId });
    }
  },
  stopLesson({ commit, state }) {
    if (!state.currentLesson) {
      return;
    }
    const { lessonId } = state.currentLesson;
    clearInterval(state.updateInterval);
    clearInterval(state.activityTimeout);
    commit("updateProgress", lessonId);
    commit("setStudyInProgress", false);
    // state.progress.forEach((activity) => {
    if (state.currentLesson === null) {
      return;
    }
    UserActivityService.updateHistory(lessonId, state.currentLesson.duration);
    // });
    // commit("setInterval", null);
    // commit("setActivityTimeout", null);
  },
};

const mutations = {
  setUserData(state, user) {
    state.userId = user.userId;
  },
  setLesson(state, lessonId) {
    // const currentLesson = state.progress.find(
    //   (activity) => activity.lessonId === lessonId
    // );
    // if (currentLesson) {
    //   currentLesson.setNewStartTime();
    //   return;
    // }
    state.currentLesson = new Activity(lessonId);
  },
  updateProgress(state, lessonId) {
    // const currentLesson = state.progress.find(
    //   (activity) => activity.lessonId === lessonId
    // );
    if (state.currentLesson) {
      state.currentLesson.updateDuration();
    }
  },
  setInterval(state, interval) {
    state.updateInterval = interval;
  },
  setActivityTimeout(state, timeout) {
    state.activityTimeout = timeout;
  },
  setStudyInProgress(state, studyInProgress) {
    state.studyInProgress = studyInProgress;
  },
};

export default {
  namespaced: true,
  state: initState,
  getters: storeGetters,
  actions,
  mutations,
};
